import { fromJS, List, Map } from 'immutable';

import * as actions from '../actions/emailTemplatesSendGrid';

const defaultForm = {
  buyer: {
    project: {
      suggestions: [],
      pagination: {},
      text: '',
      selected: null,
    },
    buyer: {
      suggestions: [],
      pagination: {},
      text: '',
      selected: null,
    },
  },
  activity: {
    suggestions: [],
    pagination: {},
    text: '',
    selected: null,
    selectedList: [],
  },
  templateName: {
    value: '',
  },
  subject: {
    value: '',
  },
  fromName: {
    value: '{{MODULE_NAME}}',
  },
  fromEmail: {
    value: '{{MODULE_EMAIL}}',
  },
};

const newTemplate = {
  ...defaultForm,
  file: null,
  htmlSource: null,
};

const editTemplate = {
  ...defaultForm,
  file: null,
  htmlSource: null,
  loading: false,
};

const defaultState = fromJS({
  loading: false,
  emailTemplates: [],
  sort: {},
  filter: defaultForm,
  newTemplate,
  editTemplate,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case actions.FETCHING_EMAIL_TEMPLATES_SEND_GRID:
      return state.merge({
        emailTemplates: [],
        loading: true,
        sort: {},
      });

    case actions.FETCHED_EMAIL_TEMPLATES_SEND_GRID_SUCCESS:
      return state.merge({
        emailTemplates: action.response.data,
        loading: false,
      });

    case actions.FETCHED_EMAIL_TEMPLATES_SEND_GRID_FAILURE:
      return state.set('loading', false);

    case actions.EMAIL_TEMPLATES_SEND_GRID_SORT: {
      const nextState = state.set(
        'sort',
        fromJS({
          [action.field]: (state.getIn(['sort', action.field]) || -1) * -1,
        }),
      );

      return nextState.set('emailTemplates', mapper(nextState, action.field));
    }

    case actions.FETCHING_EMAIL_TEMPLATE_SEND_GRID:
      return state.setIn(['editTemplate', 'loading'], true);

    case actions.FETCHED_EMAIL_TEMPLATE_SEND_GRID_SUCCESS: {
      const { data } = action.response;

      const qwe = state.mergeIn(['editTemplate'], {
        buyer: {
          project: {
            text: data.projectName,
            selected: {
              id: data.projectId,
              text: data.projectName,
            },
          },
          buyer: {
            text: data.buyerName,
            selected: {
              id: data.buyerId,
              text: data.buyerName,
            },
          },
        },
        activity: {
          text: data.activity,
          selected: {
            name: data.activity,
            value: data.activity,
          },
        },
        templateName: {
          value: data.templateName,
        },
        subject: {
          value: data.subject,
        },
        fromName: {
          value: data.fromName ?? '{{MODULE_NAME}}',
        },
        fromEmail: {
          value: data.fromEmail ?? '{{MODULE_EMAIL}}',
        },
        htmlSource: data.htmlContent,
        loading: false,
      });

      return qwe;
    }

    case actions.FETCHED_EMAIL_TEMPLATE_SEND_GRID_FAILURE:
      return state.setIn(['editTemplate', 'loading'], true);

    case actions.SET_DEFAULT_EDIT_TEMPLATE:
      return state.merge({
        editTemplate,
      });

    case actions.FETCHING_BUYER_SUGGESTIONS_START: {
      const nextState = state.mergeIn([action.name, 'buyer', action.fieldName], {
        loading: true,
        questId: action.questId,
      });

      if (!action.next) {
        return nextState.setIn([action.name, 'buyer', action.fieldName, 'suggestions'], List());
      }

      return nextState;
    }

    case actions.UPDATE_FORM: {
      // Field name could be nested. Separated by '.'. Ex.: lastAction.users
      const formName = action.formName.split('.');

      Object.keys(action.formData).forEach(key => {
        if (List.isList(action.formData[key]) || Array.isArray(action.formData[key])) {
          state = state.setIn([action.name, ...formName, key], new List());
        }
      });

      return state.mergeDeep({
        [action.name]: {
          [action.formName]: action.formData,
        },
      });
    }

    case actions.FETCHING_BUYER_SUGGESTIONS_SUCCESS: {
      if (state.getIn([action.name, 'buyer', action.fieldName, 'questId']) === action.questId) {
        return state.mergeIn([action.name, 'buyer', action.fieldName], {
          suggestions: state
            .getIn([action.name, 'buyer', action.fieldName, 'suggestions'])
            .concat(List(action.response.data)),
          loading: false,
          pagination:
            action.response.meta && action.response.meta.pagination ? Map(action.response.meta.pagination) : Map(),
        });
      }

      return state;
    }

    case actions.UPDATE_BUYER_FORM:
      Object.keys(action.formData).forEach(key => {
        if (List.isList(action.formData[key]) || Array.isArray(action.formData[key])) {
          state = state.setIn([action.name, 'buyer', action.formName, key], new List());
        }
      });

      return state.mergeDeep({
        [action.name]: {
          buyer: {
            [action.formName]: action.formData,
          },
        },
      });

    case actions.CREATE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS: {
      return state.merge({
        filter: defaultForm,
        newTemplate,
      });
    }

    case actions.DELETE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS: {
      return state.merge({
        filter: defaultForm,
      });
    }

    default:
      return state;
  }
}

const mapper = (state, field) => {
  const direction = state.getIn(['sort', field]);

  return state.get('emailTemplates').sort((a, b) => {
    const v1 = a.get(field, '');
    const v2 = b.get(field, '');

    return v1.localeCompare(v2) * direction;
  });
};
